<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M12 0a1 1 0 0 1 1 1v1h1a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h1V1a1 1 0 0 1 2 0v1h6V1a1 1 0 0 1 1-1zM3 14h2v-2H3v2zm6-2H7v2h2v-2zm4 0h-2v2h2v-2zm0-4h-2v2h2V8zM9 8H7v2h2V8zM5 8H3v2h2V8zM2 6h12V5a1 1 0 0 0-1-1 1 1 0 0 1-2 0H5a1 1 0 0 1-1.993.117L3 4a1 1 0 0 0-1 1v1z" fill="currentColor"/></svg>
</template>
<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ri-prodoffering134',
});
</script>
